export default "__VITE_ASSET__1f1d5d34__"